export default __webpack_public_path__ + "assets/5eb95a0df86042ea87253d4501c33705.svg";